import { createSlice } from "@reduxjs/toolkit";

export const loaderSlice = createSlice({
  name: "loader",
  initialState: [],
  reducers: {
    add(state: any, action: any) {
      state.push(action.payload);
    },
    remove(state: any) {
      return state.pop();
    },
  },
});

export const { add, remove } = loaderSlice.actions;
export const loaderReducer = loaderSlice.reducer;
